import React from 'react'
import { Row, Col, Button, Divider } from 'antd'
import { useTranslation } from 'next-i18next'
import { RollbackOutlined, SendOutlined } from '@ant-design/icons'

interface PropsType {
  handleCancel: any
  loading: boolean
}

const MessagereplyFormButtonsContent = ({ handleCancel, loading }: PropsType) => {
  const { t } = useTranslation()
  return (
    <>
      <Divider />
      <Row>
        <Col xs={12} lg={12}>
          <Button
            type='default'
            htmlType='button'
            size='large'
            shape='round'
            onClick={handleCancel}
            icon={<RollbackOutlined />}
          >
            {t('general.Cancel')}
          </Button>
        </Col>
        <Col xs={12} lg={12}>
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            shape='round'
            className='float-right'
            loading={loading}
            icon={<SendOutlined />}
          >
            {loading ? t('Messages.SendingReply') : t('Messages.SendReply')}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default MessagereplyFormButtonsContent
